<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('deviceManagement') }} > {{ $t('categoryType') }}</div>
    <div class="common-table-cnt common-aside-cnt-top">
      <CategoryType @handleCurrent="handleCurrent"></CategoryType>
      <div class="common-aside-main" style="right:15px;">
        <div class="search search-container">
          <!-- 根据条件查询列表 -->
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item :label="$t('mechanism')">
              <el-select
                ref="paramOuSelect"
                v-model="formInline.ouName"
                style="width:auto"
                :placeholder="$t('peaseSelect')"
                :popper-append-to-body="false"
                @change="changeParamOu"
                clearable
                @visible-change="visibleChange"
              >
                <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                  <el-tree
                    ref="typeTree"
                    node-key="id"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                    :data="data"
                    :props="defaultProps"
                    @node-click="selectParamOu"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('categoryAttribution')">
              <el-select
                v-model="typeName"
                style="width:auto"
                :placeholder="$t('peaseSelect')"
                :popper-append-to-body="false"
                clearable
                @clear="clearType"
                @visible-change="visibleChange"
              >
                <el-option :value="typeName" style="height:auto;padding:0px">
                  <el-tree
                    ref="selectJuery"
                    node-key="id"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                    :data="attributeFinds"
                    :props="defaultProps"
                    @node-click="selectJuery"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('categoryName')">
              <el-input v-model="formInline.name" clearable :placeholder="$t('categoryName')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="getList">{{ $t('query') }}</el-button>
              <el-button type="primary" @click="addUser">{{ $t('newlyAded') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="main table-box">
          <Table
            :data="tableData"
            :columns="columns"
            :operation="dateOperation"
            @getList="getList"
            @operate="operationEvent"
            :currentPage="currentPage"
            :pageSize="pageSize"
            :tableHeight="640"
            :operationWidth="120"
            ref="tanleAssembly"
            @sortChange="handleSort"
          ></Table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalData"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--新增/编辑类别窗口-->
    <el-dialog
      :title="userDialog ? $t('newlyAded') + $t('category') : $t('edit') + $t('category')"
      :visible.sync="newUserDialogTableVisible"
      class="userDialog common-blue-contain typeDialog"
      :append-to-body="true"
      width="590px"
      :close-on-click-modal="false"
    >
      <el-form :model="newTypeForm" ref="newTypeForm">
        <el-form-item :label="$t('categoryName')" :label-width="formLabelWidth" :required="true">
          <el-input
            v-model="newTypeForm.name"
            autocomplete="off"
            :placeholder="$t('pleaseEnter') + $t('categoryName')"
            class="formInput"
            clearable
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('categoryAttribution')" :label-width="formLabelWidth" :required="true">
          <el-select
            ref="categoryAttri"
            v-model="attributeName"
            style="width:auto"
            :placeholder="$t('peaseSelect')"
            :popper-append-to-body="false"
            @change="changeCategoryAttri"
            clearable
            @visible-change="visibleChange"
          >
            <el-option :value="attributeName" style="height:auto;padding:0px">
              <el-tree
                ref="selectAttribute"
                node-key="id"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
                :data="attributeFinds"
                :props="defaultProps"
                @node-click="handleTree"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('categoryTypeList')" :label-width="formLabelWidth" class="department" :required="true">
          <el-tree
            class="ouTree"
            ref="tree"
            :data="data"
            :default-checked-keys="checkedList"
            show-checkbox
            node-key="id"
            :check-strictly="true"
            :props="defaultProps"
            :default-expand-all="true"
          >
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormUser()">{{ $t('determine') }}</el-button>
        <el-button @click="cancelFrom">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from '@/components/NewTable'
import CategoryType from '@/views/new-set/device-manage/CategoryType'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { getOus } from '@/api/UserList'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { attributeTree, typePage, saveType, updateType, typeDelete } from '@/api/new-device/categoryAttribut'
export default {
  components: { Table, CategoryType, Treeselect },
  data() {
    return {
      formInline: {
        attributeId: '',
        name: '',
        ouId: '',
        ouName: '',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      // 表格数据
      tableData: [],
      columns: [],
      dateOperation: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,

      // 新增/编辑类别窗口显示
      newUserDialogTableVisible: false,
      // 新增/编辑类别 表单参数
      newTypeForm: {
        attributeId: '',
        fullTypeAttributeName: '',
        name: '',
        ouIds: '',
        remark: '',
      },
      formLabelWidth: '180px',
      // true：新增 false：编辑
      userDialog: true,
      newUserDialogTableVisibleBefore: null,

      data: [],
      // 新增/编辑类别 选择的机构
      checkedList: [],
      attributeFinds: [],
      attributeName: '',
      typeName: '',
    }
  },
  watch: {},
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order === 'descending' ? 0 : 1
      this.getList()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    selectJuery(data) {
      // 选择归属
      this.typeName = data.name
      this.formInline.attributeId = data.id
    },
    clearType() {
      this.typeName = ''
      this.formInline.attributeId = ''
    },
    // 新增时当前选择的归属
    handleTree(data) {
      this.attributeName = data.name
      this.newTypeForm.attributeId = data.id
      this.$refs.categoryAttri.blur()
    },
    // 新增时清空过滤归属，
    changeCategoryAttri(data) {
      if (!data) {
        this.attributeName = null
        this.newTypeForm.attributeId = ''
        this.$nextTick(() => {
          this.$refs.selectAttribute.setCurrentKey(null)
        })
      }
    },
    normalizer(node) {
      // 去掉children=null的children属性
      if (node.children === null) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    // 选择的归属、
    handleCurrent(val) {
      // 新增时默认归属
      this.attributeName = val.name
      this.newTypeForm.attributeId = val.id
      // 查询的归属
      this.typeName = val.name
      this.formInline.attributeId = val.id
      this.getList()
    },

    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 获取类别归属列表
    getattributeFind() {
      let params = {
        name: '',
        isContainMediaType: 1,
        isReject: 1,
      }
      attributeTree(params).then(res => {
        if (res.state === 0) {
          this.attributeFinds = res.value
        }
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.data = res.data
        }
      })
    },
    // 新增选择类别归属
    handleFind(val) {
      if (val) {
        this.attributeFinds.map(item => {
          if (item.id === val) {
            this.newTypeForm.fullTypeAttributeName = item.fullTypeAttributeName
          }
        })
      }
    },
    // 查询
    getList() {
      this.currentPage = 1
      this.search()
    },
    // 获取类别列表
    search() {
      let params = {
        attributeId: this.formInline.attributeId,
        name: this.formInline.name,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc
      }
      typePage(params).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
    },
    // 新增类别
    addUser() {
      this.userDialog = true
      this.getattributeFind()
      this.newTypeForm = {
        attributeId: this.newTypeForm.attributeId ? this.newTypeForm.attributeId : null,
        fullTypeAttributeName: '',
        name: '',
        ouIds: '',
      }
      this.checkedList = []
      this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.checkedList)
        })
      this.attributeName = ''
      this.newUserDialogTableVisible = true
    },
    // 删除类别
    delUser(row) {
      this.$confirm(this.$t('deleteThisCategory'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = [row.id]
        typeDelete(param).then(res => {
          if (res.state === 0) {
            this.search()
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
          }
        })
      })
    },
    // 提交新增类别
    submitFormUser() {
      let obj = this.newTypeForm
      let NodesArr = this.$refs.tree.getCheckedNodes()
      let idArr = []
      for (let item of NodesArr) {
        if (item.id) {
          idArr.push(item.id)
        }
      }
      if (this.userDialog) {
        let param = {
          attributeId: obj.attributeId,
          name: obj.name,
          ouIds: idArr,
        }
        if (!param.name || param.name === '') {
          this.$message.error(this.$t('pleaseEnter') + this.$t('categoryName'))
          return
        } else if (!param.attributeId || param.attributeId === '') {
          this.$message.error(this.$t('peaseSelect') + this.$t('categoryAttribution'))
          return
        } else if (!param.ouIds || idArr.length === 0) {
          this.$message.error(this.$t('peaseSelect') + this.$t('categoryTypeList'))
          return
        } else {
          this._saveAddUser(param)
        }
      } else {
        this._saveEditUser(obj, idArr)
      }
    },
    _saveAddUser(param) {
      saveType(param).then(res => {
        if (res.state === 0) {
          this.search()
          this.$message({
            type: 'success',
            message: this.$t('AddSuccess'),
          })
          this.newUserDialogTableVisible = false
        }
      })
    },
    _saveEditUser(obj, idArr) {
      let param = {
        attributeId: obj.attributeId,
        name: obj.name,
        ouIds: idArr,
        id: obj.id,
      }
      if (!param.name) {
        errorCollection('设置》设备管理', '新增/编辑类别', {
          status: 200,
          data: { state: -1, msg: '请输入类别名称' },
        })
        this.$message.error(this.$t('pleaseEnter') + this.$t('categoryName'))
        return
      } else if (!param.attributeId) {
        errorCollection('设置》设备管理', '新增/编辑类别', {
          status: 200,
          data: { state: -1, msg: '请选择类别归属' },
        })
        this.$message.error(this.$t('peaseSelect') + this.$t('categoryAttribution'))
        return
      } else if (!param.ouIds || idArr.length === 0) {
        errorCollection('设置》设备管理', '新增/编辑类别', {
          status: 200,
          data: { state: -1, msg: '请选择适用机构' },
        })
        this.$message.error(this.$t('categoryTypeList'))
        return
      } else {
        updateType(param).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('EditSucceeded'),
            })
            this.newUserDialogTableVisible = false
            this.search()
          }
        })
      }
    },
    cancelFrom() {
      this.newUserDialogTableVisible = false
      this.search()
    },
    // 编辑类别
    UserEditHandleClick(row) {
      this.newUserDialogTableVisibleBefore = Object.assign({}, row)
      this.userDialog = false
      this.newUserDialogTableVisible = true

      this.$nextTick(() => {
        this.newTypeForm = this.newUserDialogTableVisibleBefore
        this.attributeName = this.newTypeForm.attributeName
        this.checkedList = this.newTypeForm.ouIdsStr.split(',')
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.checkedList)
        })
      })
    },
    // 每页查询 val 条数据
    handleSizeChange(val) {
      this.pageSize = val
      this.search()
    },
    // 点击页数跳转到 val 页
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this.delUser(row.value)
      } else if (row.type === 'edit') {
        this.getattributeFind()
        this.UserEditHandleClick(row.value)
      }
    },
    basicConfig() {
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'fullTypeAttributeName',
          label: this.$t('categoryAttribution'),
          sort: 'fullTypeAttributeName',
        },
        {
          attrName: 'name',
          label: this.$t('categoryName'),
          sort: 'name',
        },
        {
          attrName: 'fullOuName',
          label: this.$t('categoryTypeList'),
          sort: 'fullOuName',
        },
      ]
      // table 操作栏配置
      this.dateOperation = [
        {
          operateName: this.$t('edit'),
          icon: '',
          type: 'edit',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          icon: '',
          type: 'delect',
          class: 'editClick',
        },
      ]
    },
  },
  mounted() {
    this.search()
    this.basicConfig()
    this.getOusTree()
    this.getattributeFind()
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-tree-node__content:hover .editBtn
  display inline-block
.base_main
  .common-aside-main
    left 19%!important
    margin-left 15px
  .common-table-cnt
    padding 0px!important
  .serachBar
    padding 10px
    font-weight: bold
    font-size 16px
    // color #fff
  .serachBtn
    margin-left 40%
  .serachBar:before
    display inline-block
    content ''
    width 3px
    height 15px
    margin-right 10px
    border-radius 3px
    background-color #00DDFE
    .el-input
      width 100%
  .editBtn
    display none
    .addicon
      margin-right 10%
      width 20px
      height 20px
  .title
    font-size 16px
    margin-bottom 28px
  .main
    .user_input
      margin-top 10px
      width 100px
      margin-left 10px
    .el-button
      margin-left 10px
    .pagination
      float right
      margin-top 1%
>>>.el-popper
 width 100%!important
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.userDialog
  >>>.el-popper
    width 358px!important; /* no */
  .ouTree
    border: 1px solid #DCDFE6
    height 360px
    // width 400px
    overflow auto
    background: var(--fence-tree-bg) !important;
    color: var(--aside-color) !important;
    border: var(--fence-tree-border)!important;
    border-radius: 4px;
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 644px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
